import { makeObservable, observable, action, computed } from "mobx";
// import { runInAction } from "mobx";
import { getAppList } from "utils/api";

// const apps = [
//   {
//       "appId": 501946,
//       "appKey": "FF9C33DBB4CE59AA0C4F3C97AC1711ED",
//       "appName": "vop质量部1测试用",
//       "appType": "1814",
//       "stateLabelDesc": "待审核",
//       "xpin": "guoyaori1"
//   },
//   {
//       "appId": 494355,
//       "appKey": "14516D62DF6A8BABE498ADC334966E6B",
//       "appName": "VOP测试5",
//       "appType": "1814",
//       "contractNumber": "VOP-20190226142611",
//       "stateLabelDesc": "上线运行",
//       "xpin": "guoyaori1"
//   }
// ];

export default class FrameStore {
  apps = [];
  totalCount = 0;
  currentApp = null;
  showAppList = false;
  frameLoading = false;
  pageLoading = false;
  loaded = false;

  appsMap = {};

  constructor() {
    makeObservable(this, {
      apps: observable,
      totalCount: observable,
      currentApp: observable,
      showAppList: observable,
      loaded: observable,
      frameLoading: observable,
      pageLoading: observable,
      loadApps: action,
      changeApp: action,
      addApp: action,
      updateAppName: action,
      toggleAppList: action,
      hideAppList: action,
      startFrameLoading: action,
      endFrameLoading: action,
      startPageLoading: action,
      endPageLoading: action,
      currentAppName: computed,
      firstChar: computed,
    });
  }

  get currentAppName() {
    let appName =
      this.currentApp && this.currentApp.appName ? this.currentApp.appName : "";

    if (!appName && this.apps.length <= 0) {
      appName = this.loaded ? "未创建应用" : "";
    }

    return appName;
  }

  get currentAppKey() {
    return this.currentApp && this.currentApp.appKey
      ? this.currentApp.appKey
      : "";
  }

  get firstChar() {
    return this.currentApp && this.currentApp.appName
      ? this.currentApp.appName.substr(0, 1)
      : "无";
  }

  async loadApps() {
    const result = await getAppList({
      pageIndex: 1,
    });

    this.loaded = true;

    const resp = result.data;
    if (resp && resp.success && resp.result && Array.isArray(resp.result.items)) {
      const apps = resp.result.items;

      this.appsMap = {};
      // this.apps = [];
      this.apps = apps;
      apps.forEach((app) => (this.appsMap[app.appKey] = app));
      this.totalCount = resp.result.pageItemTotal;

      window['appsMap'] = this.appsMap;
    }
  }

  changeApp(newAppkey) {
    if (!newAppkey) {
      // console.error('newAppkey不能为空');
      return;
    }

    if (!this.appsMap[newAppkey]) {
      console.error("应用不存在");
      return;
    }

    if (!this.currentApp || newAppkey !== this.currentApp.appKey) {
      this.currentApp = this.appsMap[newAppkey];
      return true;
    }

    return false;
  }

  addApp(app) {
    this.apps.push(app);
  }

  hasApp(appKey) {
    return this.appsMap && this.appsMap[appKey];
  }

  updateAppName(name) {
    this.currentApp.appName = name;
    this.apps.forEach((app) => {
      if (app.appKey === this.currentAppKey) {
        app.appName = name;
      }
    });
  }

  toggleAppList() {
    if (this.apps && this.apps.length) {
      this.showAppList = !this.showAppList;
    }
  }

  hideAppList() {
    this.showAppList = false;
  }

  startFrameLoading() {
    this.frameLoading = true;
  }

  endFrameLoading() {
    this.frameLoading = false;
  }

  startPageLoading() {
    this.pageLoading = true;
  }

  endPageLoading() {
    this.pageLoading = false;
  }
}
